import React from 'react';
import { styled } from '@mui/material/styles';
import {
	Grid,
	Paper,
	Table,
	TableBody,
	TableContainer,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';

import { LocationResult } from '@horasys/bellplus/common/types';
const PREFIX = 'LocationGroupSlotResultPage';

const classes = {
	head: `${PREFIX}-head`,
	body: `${PREFIX}-body`,
	root: `${PREFIX}-root`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
	[`& .${classes.head}`]: {
		//backgroundColor: theme.palette.common.black,
		backgroundColor: '#085DAD',
		color: theme.palette.common.white,
	},

	[`& .${classes.body}`]: {
		fontSize: 14,
	},

	[`& .${classes.root}`]: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
	},
}));

export default function LocationGroupSlotResultPage({
	slotResults,
}: {
	slotResults: Array<LocationResult>;
}) {
	const StyledTableCell = TableCell;

	const StyledTableRow = TableRow;

	return (
		<StyledGrid container>
			{' '}
			{slotResults && slotResults.length > 0 && (
				<>
					<Grid item xs={12}>
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow>
										<StyledTableCell
											align="center"
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Location Group Name{' '}
										</StyledTableCell>
										<StyledTableCell
											align="center"
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Selected devices{' '}
										</StyledTableCell>
										<StyledTableCell
											align="center"
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Selected Slots{' '}
										</StyledTableCell>
										<StyledTableCell
											align="center"
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Ad Cost{' '}
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{slotResults != null &&
										slotResults.map(
											(data: LocationResult, index: any) => {
												return (
													<StyledTableRow
														key={index}
														classes={{
															root: classes.root,
														}}>
														<StyledTableCell
															align="center"
															component="th"
															scope="row"
															classes={{
																head: classes.head,
																body: classes.body,
															}}>
															<Typography>
																{' '}
																{data.name}
															</Typography>
														</StyledTableCell>
														<StyledTableCell
															align="center"
															component="th"
															scope="row"
															classes={{
																head: classes.head,
																body: classes.body,
															}}>
															<Typography>
																{' '}
																{data.selectedDeviceCount}
															</Typography>
														</StyledTableCell>
														<StyledTableCell
															align="center"
															component="th"
															scope="row"
															classes={{
																head: classes.head,
																body: classes.body,
															}}>
															<Typography>
																{' '}
																{data.noOfTimes}
															</Typography>
														</StyledTableCell>
														<StyledTableCell
															align="center"
															component="th"
															scope="row"
															classes={{
																head: classes.head,
																body: classes.body,
															}}>
															<Typography>
																{' '}
																{data.budget}
															</Typography>
														</StyledTableCell>
													</StyledTableRow>
												);
											},
										)}
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				</>
			)}
		</StyledGrid>
	);
}
